import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./musicRequestHomeStyle.css";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";

export default function MusicRequestHome() {
    const navigate = useNavigate();

    const [events, setEvents] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [showCodePopup, setShowCodePopup] = useState(false);

    const [title, setTitle] = useState("");
    const [location, setLocation] = useState("");
    const [code, setCode] = useState("");
    const [eventId, setEventId] = useState("");

    useEffect(() => {
        document.title = "DJ - EMAN"
        getEvents();
        const role = localStorage.getItem("role");
        if (role === "admin") {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }
    }, []);

    const getEvents = async () => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/events?token=" + Cookies.get("token"), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                const data = await response.json();
                setEvents(data);
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    function switchSide(side) {
        navigate(side);
    }

    function addEvent() {
        if (!showPopup) {
            setShowPopup(true);
        }
    }

    const handleCreateEvent = async (e) => {
        setShowPopup(false);
        e.preventDefault();

        const eventData = {
            title: title,
            location: location,
            code: code,
        }

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/addevent?token=" + Cookies.get("token"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(eventData),
            });

            if (response.ok) {
                window.location.reload();
            } else {
                toast.error("Es ist ein Fehler beim erstellen des Events aufgetreten");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }

        setTitle("");
        setLocation("");
    }

    function closePopup() {
        setShowPopup(false);
        setShowCodePopup(false);
        setTitle("");
        setLocation("");
        setCode("");
        setEventId("");
    }

    function openSettingsSide() {
        navigate("/settings");
    }

    function logout() {
        Cookies.remove("token");
        localStorage.removeItem("id");
        localStorage.removeItem("username");
        localStorage.removeItem("role");
        navigate("/login");
    }

    function openCodePopup(eventId, eventCode) {
        if (eventCode) {
            setEventId(eventId);
            setShowCodePopup(true);
        } else {
            switchSide("/musicrequestevent?id=" + eventId);
        }
    }

    const handleEventCode = async (e) => {
        setShowCodePopup(false);
        e.preventDefault();

        const eventCodeData = {
            eventCode: code,
            eventId: eventId,
        }

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/event-code-check?token=" + Cookies.get("token"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(eventCodeData),
            });

            if (response.ok) {
                switchSide("/musicrequestevent?id=" + eventId + "&code=" + code);
            } else {
                toast.error("Der Code ist nicht gültig");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }

        setCode("");
        setEventId("");
    }

    return (
        <div className="musicRequestHomeContainer">
            <ToastContainer
                theme="dark"
            />
            <h1>Aktuelle Events</h1>
            <img className="settings" onClick={() => openSettingsSide()} src="/img/settings.svg" />
            {isAdmin && (
                <img className="halfShield" onClick={() => switchSide("/administration")}src="/img/half-shield.svg" />
            )}
            {isAdmin && (
                <div className="plusContainer" onClick={() => addEvent()}>
                    <img src="/img/plus.svg" />
                    <h3>Event erstellen</h3>
                </div>
            )}
            {events.filter(event => event.state === 1).map((event) => (
                <div className="eventContainer" onClick={() => openCodePopup(event.id, event.hasCode)}>
                    <div className="titleLocationContainer">
                        <h2>{event.title}</h2>
                        <div className="imgTextContainer">
                            <img src="/img/location.svg" />
                            <h3>{event.location}</h3>
                        </div>
                    </div>
                    <h4>Klicke um das Event zu öffnen</h4>
                </div>
            ))}
            {isAdmin && (
                <>
                <hr />
                <h2>Event Archiv</h2>
                {events.filter(event => event.state === 0).map((event) => (
                    <div className="eventContainerArchiv" onClick={() => openCodePopup(event.id, event.hasCode)}>
                        <div className="titleLocationContainer">
                            <h2>{event.title}</h2>
                            <div className="imgTextContainer">
                                <img src="/img/location.svg" />
                                <h3>{event.location}</h3>
                            </div>
                        </div>
                        <h4>Klicke um das Event zu öffnen</h4>
                    </div>
                ))}
            </>
            )}
            {showPopup && (
                <div id="popup">
                    <form onSubmit={handleCreateEvent}>
                        <h1>Event Erstellen</h1>
                        <img className="closeButton" onClick={() => closePopup()} src="/img/xMarkWhite.svg" />
                        <input
                            type="text"
                            placeholder="Titel"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="Location"
                            value={location}
                            onChange={(e) => setLocation(e.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="Code"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                        />
                        <button type="submit">Erstellen</button>
                    </form>
                </div>
            )}
            {showCodePopup && (
                <div id="popup">
                    <form onSubmit={handleEventCode}>
                        <h1>Event Code</h1>
                        <img className="closeButton" onClick={() => closePopup()} src="/img/xMarkWhite.svg" />
                        <input
                            type="text"
                            placeholder="Code"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                        />
                        <button type="submit">Weiter</button>
                    </form>
                </div>
            )}
            <button className="logoutButton" onClick={() => logout()}>Logout</button>
        </div>
    )
}
